import { render, staticRenderFns } from "./RouteSidebarRecords.vue?vue&type=template&id=1d643a52&scoped=true"
import script from "./RouteSidebarRecords.vue?vue&type=script&lang=js"
export * from "./RouteSidebarRecords.vue?vue&type=script&lang=js"
import style0 from "./RouteSidebarRecords.vue?vue&type=style&index=0&id=1d643a52&prod&lang=scss"
import style1 from "./RouteSidebarRecords.vue?vue&type=style&index=1&id=1d643a52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d643a52",
  null
  
)

export default component.exports